import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetChallengeTranslationRequest } from './get-challenge-translation-request';
import type { IGetChallengeTranslationResponse } from './get-challenge-translation-response';
import { getChallengeTranslationResponseSchema } from './get-challenge-translation-response';

export async function getChallengeTranslationApi({
  challengeId,
  translationId,
}: IGetChallengeTranslationRequest): Promise<IValidatedResponse<IGetChallengeTranslationResponse>> {
  return getRequest<IGetChallengeTranslationResponse>({
    path: `/sys/challenges/${challengeId}/translations/${translationId}`,
    schema: getChallengeTranslationResponseSchema,
  });
}
